import { Injectable, EventEmitter } from '@angular/core';
import { OptionsGenericType } from '../../../../models/interfaces';
import { TranslateService } from '../../../../core/translation';
import { operationTypeEnum } from '../../../../models/operation-type';
import { CircuitBeanP } from '../../../../api/model/circuitBeanP';
import { IvcertContacts } from '../../../../api/model/ivcertContacts';


@Injectable({
  providedIn: 'root'
})
export class TableService {

  clear: EventEmitter<boolean> = new EventEmitter<boolean>();

  isDisabledPermission: boolean = true;

  selectedPage: string = '';

  cacheFilters: unknown = {};

  constructor(private _translate: TranslateService) { }

  validateKebabOptionsContact(contact: IvcertContacts, kebabOptions: OptionsGenericType[]): OptionsGenericType[] {
    if (contact.isPrivate) {
      kebabOptions[1].value = this._translate.instant('contacts.button_kebab_public');
    } else {
      kebabOptions[1].value = this._translate.instant('contacts.button_kebab_private');
    }

    return kebabOptions;
  }

  validateKebabOptionsArea(area: any, kebabOptions: OptionsGenericType[]): OptionsGenericType[] {
    const indexRemove = kebabOptions.findIndex((x) => x.key === 'k_delete');
    const indexActive = kebabOptions.findIndex((x) => x.key === 'k_active' || x.key === 'k_desactive');

    if (area?.numUsers > 0) {
      kebabOptions[indexRemove].disabled = true;
    } else {
      kebabOptions[indexRemove].disabled = false;
    }

    if (area?.active) {
      kebabOptions[indexActive].value = this._translate.instant('areas.desactivate');
    } else {
      kebabOptions[indexActive].value = this._translate.instant('areas.activate');
    }

    return kebabOptions;
  }

  validateKebabOptionsRecipients(recipient: any, kebabOptions: OptionsGenericType[], blockReceivers?: boolean): OptionsGenericType[] {
    const hasOperationTypeSigorga = recipient.operationType === operationTypeEnum.SIGORGA;

    if (!hasOperationTypeSigorga) {
      kebabOptions = [
        { key: 'k_modifyReceiver', value: this._translate.instant('detallecircuito_modificar_correo'), disabled: blockReceivers || recipient.blocked },
        { key: 'k_edit', value: this._translate.instant('recipients.button_kebab_edit'), disabled: !recipient.operationType },
        { key: 'k_permissions', value: this._translate.instant('newcircuit_btn_permission'), disabled: this.isDisabledPermission || blockReceivers || recipient.blocked },
        { key: 'k_duplicate', value: this._translate.instant('recipients.button_kebab_duplicate'), disabled: blockReceivers || recipient.blocked },
        { key: 'k_delete', value: this._translate.instant('recipients.button_kebab_delete'), disabled: blockReceivers || recipient.blocked }
      ];

      return kebabOptions;
    }

    kebabOptions = [
      { key: 'k_edit', value: this._translate.instant('recipients.button_kebab_edit') },
      { key: 'k_delete', value: this._translate.instant('recipients.button_kebab_delete') }
    ];
    return kebabOptions;
  }

  validateKebabOptionsCustomRecipients(recipient: any, kebabOptions: OptionsGenericType[], blockReceivers?: boolean): OptionsGenericType[] {
    const hasOperationTypeSigorga = recipient.operationType === operationTypeEnum.SIGORGA;

    if (!hasOperationTypeSigorga) {
      kebabOptions = [
        { key: 'k_modifyReceiver', value: this._translate.instant('detallecircuito_modificar_correo') },
        { key: 'k_edit', value: this._translate.instant('recipients.button_kebab_edit') },
        { key: 'k_duplicate', value: this._translate.instant('recipients.button_kebab_duplicate') },
        { key: 'k_delete', value: this._translate.instant('recipients.button_kebab_delete'), disabled: recipient?.blocked },
      ];

      if (!blockReceivers) {
        kebabOptions.push({
          key: 'k_block', value: this._translate.instant(
            recipient.blocked ?
              'recipients.button_kebab_unblock' :
              'recipients.button_kebab_block'
          )
        })
      }

      return kebabOptions;
    }

    kebabOptions = [
      { key: 'k_edit', value: this._translate.instant('recipients.button_kebab_edit') },
      { key: 'k_delete', value: this._translate.instant('recipients.button_kebab_delete') }
    ];

    if (recipient.blocked) {
      kebabOptions = [{ key: 'k_edit', value: this._translate.instant('recipients.button_kebab_edit') }];
    }

    return kebabOptions;
  }

  validateKebabOptionsSentCircuits(circuit: CircuitBeanP, kebabOptions: OptionsGenericType[]): OptionsGenericType[] {
    const state: number[] = [2, 3, 4, 5];

    if (state.includes(circuit.idState)) {
      kebabOptions = [
        { key: 'k_seeDetails', value: this._translate.instant('miscircuitos_toolbar_0') }
      ];
    }

    return kebabOptions;
  }

  clearSelection(): void {
    this.clear.emit(true);
  }

  setCacheFilters(page: string, filters: unknown): void {
    this.selectedPage = page
    this.cacheFilters = filters;
  }

  getCacheFilters(page: string): unknown {
    if(page === this.selectedPage){
      return this.cacheFilters;
    }
    if(page !== this.selectedPage && page !== 'evidencias'){
      this.cacheFilters = null;
    }
  }

}
